import { styled } from '@mui/material/styles';

import { palette, Theme } from '../../../theme';
import { Icon } from '../../Icon';

export const StyledHeading = styled('div')`
    display: flex;
    padding: ${({ theme }: { theme: Theme }) => theme.tggSpacing([3.5, 6])};
    font-size: 1.6rem;
    font-weight: 800;
    background-color: ${palette.common.blue};
`;

export const StyledBody = styled('div')`
    padding: ${({ theme }: { theme: Theme }) => theme.tggSpacing([4, 6])};

    ul {
        padding: 0;
    }

    .discount-message {
        ${({ theme }: { theme: Theme }) => theme.typography.bodyXXSmall};
    }
`;

export const StyledGymBagTileFooter = styled('div')`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }: { theme: Theme }) => theme.tggSpacing(4)};
    align-items: start;
    padding: ${({ theme }: { theme: Theme }) => theme.tggSpacing([4, 6])};
    background-color: ${palette.grey[50]};
    border-bottom-right-radius: 0.8rem;
    border-bottom-left-radius: 0.8rem;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        padding: ${({ theme }: { theme: Theme }) => theme.tggSpacing(6)};
    }
`;

export const StyledPromoCode = styled('div')`
    display: flex;
    gap: ${({ theme }: { theme: Theme }) => theme.tggSpacing(1)};
    align-items: center;
    justify-content: center;
`;

export const StyledPromoCodeText = styled('div')`
    ${({ theme }: { theme: Theme }) => theme.typography.bodySmall};
`;

export const StyledTotalCostWrapper = styled('div')<{
    $gutterBottom?: boolean;
    theme: Theme;
}>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const StyledTotalCostText = styled('div')`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_14_bold_desktop_16};
    color: ${({ theme }: { theme: Theme }) => theme.palette.tgg.text.body.main};
`;

export const StyledDealsIcon = styled(Icon)`
    margin-bottom: ${({ theme }: { theme: Theme }) => theme.tggSpacing(1)};
`;
